import { cn } from "@/lib/utils";
import { Check, MapPin, Calendar } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const TraceabilityPanel = ({ traceability, materialComposition, className }) => {
  if (!traceability) return null;

  const formatDate = (dateStr) => {
    return dateStr;
  };

  return (
    <div className={cn("bg-card rounded-xl border border-border overflow-hidden", className)}>
      {/* Header */}
      <div className="bg-secondary/30 px-6 py-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-lg font-semibold text-foreground">Traceability</h3>
          <Badge variant="outline" className="text-xs">
            <Check className="h-3 w-3 mr-1" />
            Verified
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground mt-1">Follow the complete journey of your product</p>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Material Composition */}
        <div className="mb-6 pb-6 border-b border-border">
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
            Material Composition
          </span>
          <p className="text-base font-medium text-foreground mt-1">{materialComposition}</p>
        </div>

        {/* Production Timeline */}
        <div>
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
            Production Timeline
          </span>
          <div className="mt-4 space-y-0">
            {traceability.steps.map((step, index) => (
              <div key={index} className="relative pl-8 pb-6 last:pb-0">
                {/* Timeline line */}
                {index < traceability.steps.length - 1 && (
                  <div className="absolute left-[11px] top-6 w-px h-full bg-border" />
                )}
                {/* Timeline dot */}
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary" />
                </div>
                {/* Content */}
                <div>
                  <h4 className="font-medium text-foreground">{step.name}</h4>
                  <div className="mt-1 space-y-1">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <span className="font-medium">{step.partner}</span>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <MapPin className="h-3 w-3" />
                        {step.location}
                      </span>
                      <span className="flex items-center gap-1">
                        <Calendar className="h-3 w-3" />
                        {formatDate(step.date)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Last Updated */}
        <div className="mt-6 pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground">
            Last updated: {traceability.lastUpdated}
          </p>
        </div>
      </div>
    </div>
  );
};
